import {useDispatch, useSelector} from "react-redux";
import {Empty, notification} from "antd";
import {useContext, useEffect, useState} from "react";
import _ from "lodash";
import {
    Button,
    Icon,
    Loading,
    Modal
} from "../../../components";
import {
    requestDemoActions,
    requestDemoErrorSelector,
    requestDemoFilterSelector,
    requestDemoItemsSelector,
    requestDemoLoadingSelector,
    requestDemoPaginationSelector
} from "../RequestDemoSlice";
import ActionBar from "../../../layout/ActionBar";
import {useCan} from "../../../hooks";
import {requestDemoApi} from "../../../api";
import {apiError, handleRequest} from "../../../utils";
import {
    RequestDemoTable,
    RequestDemoFormAdd,
    RequestDemoFormEdit,
    RequestDemoSearchBar
} from "../components";
import {AppContext} from "../../../context/AppProvider";

function RequestDemo()
{
    const {
        socket,
    } = useContext(AppContext);

    const can = {
        add: useCan('requestDemoAdd'),
        edit: useCan('requestDemoEdit'),
        delete: useCan('requestDemoDelete'),
        status: useCan('requestDemoStatus'),
    }

    const dispatch = useDispatch();

    const items = useSelector(requestDemoItemsSelector)

    const loading = useSelector(requestDemoLoadingSelector)

    const error = useSelector(requestDemoErrorSelector)

    const pagination = useSelector(requestDemoPaginationSelector)

    const filter = useSelector(requestDemoFilterSelector)

    const [itemEdit, setItemEdit] = useState({});

    const [loadingDelete, setLoadingDelete] = useState(false);

    //Model
    const [openModal, setOpenModal] = useState({
        add 	 : false,
        edit    : false,
        delete    : false,
    });

    const handleModalOpen = (modal) => {
        openModal[modal] = true;
        setOpenModal({...openModal})
    }

    const handleModalClose = (modal) => {
        openModal[modal] = false;
        setOpenModal({...openModal});
    }

    const eventsHandler = {
        load: () =>
        {
            dispatch(requestDemoActions.fetchData({
                ...filter,
                detail: ['user']
            }))
        },
        search: (newFilter) => {
            dispatch(requestDemoActions.setFilterWithDebounce({
                ...newFilter, detail: ['user']
            }));
        },
        changePagination: (page) =>
        {
            dispatch(requestDemoActions.setFilter({
                ...filter, detail: ['user'], page
            }))
        },
        changeStatus: async (item, status) =>
        {
            if (!item?.id) {
                notification.error({message: 'Lỗi', description: 'Không có thông tin yêu cầu dịch vụ'});
                return;
            }

            let [error, response] = await handleRequest(requestDemoApi.status({
                status: status,
                id: item.id
            }));

            let message = apiError(`Cập nhật trạng thái yêu cầu thất bại`, error, response);

            if (!message)
            {
                notification.success({
                    message: 'Thành công',
                    description: `Cập nhật trạng thái yêu cầu thành công`
                });
                let newItem = JSON.parse(JSON.stringify(item));

                newItem.status = response.data.status;

                dispatch(requestDemoActions.update(newItem));

                socket.emit("set-notification-user", response.data.notification);
            }
        },
        add: async (data) =>
        {
            let [error, response] = await handleRequest(requestDemoApi.add(data));

            let message = apiError(`Thêm yêu cầu thất bại`, error, response);

            if (!message)
            {
                notification.success({
                    message: 'Thành công',
                    description: `Thêm yêu cầu thành công`
                });

                dispatch(requestDemoActions.add(response.data.item));

                socket.emit("set-notification-user", response.data.notification);

                handleModalClose('add');
            }
        },
        edit: async (item, data) =>
        {
            if (!item?.id)
            {
                notification.error({message: 'Lỗi', description: 'Không có thông tin yêu cầu'});

                return false;
            }

            data.id = item.id;

            let [error, response] = await handleRequest(requestDemoApi.updateUrl(data));

            let message = apiError(`Cập nhật yêu cầu thất bại`, error, response);

            if (!message)
            {
                notification.success({
                    message: 'Thành công',
                    description: `Cập nhật yêu cầu thành công`
                });

                item.url = response.data.url;

                dispatch(requestDemoActions.update({
                    ...item
                }));

                handleModalClose('edit');
            }
        },
        delete: async () =>
        {
            if (!itemEdit?.id)
            {
                notification.error({message: 'Lỗi', description: 'Không có thông tin yêu cầu để đăng nhập'});

                return false;
            }

            setLoadingDelete(true);

            let [error, response] = await handleRequest(requestDemoApi.delete(itemEdit.id));

            let message = apiError(`Xóa yêu cầu thất bại`, error, response);

            if (!message)
            {
                notification.success({
                    message: 'Thành công',
                    description: `Xóa yêu cầu thành công`
                });

                dispatch(requestDemoActions.delete(itemEdit.id));

                handleModalClose('delete');
            }

            setLoadingDelete(false);
        },
    }

    useEffect(() => {
        eventsHandler.load()
    }, [filter])

    if(error)
    {
        notification.error({
            message: 'Có lỗi xảy ra',
            description: error,
        })
    }

    return (
        <>
            <ActionBar title={'Danh sách yêu cầu'}>
                {can.add && <Button outline leftIcon={Icon.plusCircle} onClick={() => {handleModalOpen('add')}}>Thêm mới</Button>}
                <Button outline small onClick={eventsHandler.load} style={{fontSize:'20px'}}>{Icon.reload}</Button>
            </ActionBar>
            <div className="container">
                <div className="content">
                    {loading && <Loading />}
                    <RequestDemoSearchBar filter={filter} onSearchChange={eventsHandler.search} />
                    {!_.isEmpty(items) && <RequestDemoTable
                        items={items}
                        can={can}
                        pagination={pagination}
                        onPaginationChange={eventsHandler.changePagination}
                        handleStatus={eventsHandler.changeStatus}
                        onHandleLoginHost={eventsHandler.loginHost}
                        onHandleLoginDb={eventsHandler.loginDb}
                        onHandleFtpCreated={eventsHandler.ftpCreated}
                        openModal={handleModalOpen}
                        setItemEdit={setItemEdit}
                    />}
                    {_.isEmpty(items) && <Empty />}
                </div>
            </div>
            {
                ((can.add && openModal.add)) && <Modal title="Thêm Yêu Cầu" visible={openModal.add} onCancel={() => {handleModalClose('add')}}>
                    <RequestDemoFormAdd onHandleSubmit={eventsHandler.add} />
                </Modal>
            }
            {
                ((can.edit && openModal.edit)) && <Modal title="Cập nhật Yêu Cầu" visible={openModal.edit} onCancel={() => {handleModalClose('edit')}}>
                    <RequestDemoFormEdit item={itemEdit} onHandleSubmit={eventsHandler.edit} />
                </Modal>
            }
            {
                (can.delete && itemEdit?.id && openModal.delete) && <Modal title="Xóa yêu cầu thông tin host" visible={openModal.delete} onCancel={() => {handleModalClose('delete')}}>
                    <p>Bạn muốn xóa yêu cầu cho tên miền <b>{itemEdit?.domain}</b>?</p>
                    <br />
                    <div className="d-flex justify-content-end gap">
                        <Button white leftIcon={Icon.close} onClick={() => {handleModalClose('delete')}}> Đóng </Button>
                        <Button loading={loadingDelete} primary leftIcon={Icon.delete} onClick={eventsHandler.delete}> Xóa </Button>
                    </div>
                </Modal>
            }
        </>

    )
}

export default RequestDemo;